import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'ebo-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent {
  @Input() url?: string;

  constructor(
    private location: Location,
    private router: Router
  ) {}

  goBack(): void {
    if (this.url) {
      this.router.navigateByUrl('/' + this.url);
    } else {
      this.location.back();
    }
  }
}
